import { userSubscriptionLevel } from '@modules/auth/types'
import { FEATURE_FLAGS_CONFIG } from '@modules/config/feature-flag-config'
import { useQuery } from '@tanstack/react-query'

import configApi from '../api'

export const useUserConfig = () => {
  const { data } = useQuery({
    queryFn: configApi.fetchUserConfig.fn,
    queryKey: [configApi.fetchUserConfig.key],
    placeholderData: {
      featureFlags: FEATURE_FLAGS_CONFIG[userSubscriptionLevel.SUBSCRIBED_USER],
    },
  })

  return {
    ...(data || {}),
  }
}
